<template>
  <div>
    <page-header
      :page="page"
      :actions="headerActionConfig"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <academic-progress-calendar
      class="mb-4"
      v-if="isAcademicProgressCalendarVisible"
    ></academic-progress-calendar>

    <filter-manager
      ref="filter"
      v-model="filter.model"
      :filters="filtersHeader"
      @search="searchHandler"
      @academicYear="onAcademicYearChange"
      @status="onStatusChange"
      @center="onCenterChange"
      @municipality="onMunicipalityChange"
      @school="onSchoolChange"
      @alternativeLocationCategory="onAlternativeLocationCategoryChange"
      class="filter-manager_extended"
      search-container-class="search-btn"
      :open-advanced="filterSchoolIsRequired"
    />
    <status-legend v-if="!showNotResults"></status-legend>
    <div class="row my-3 mx-0">
      <div class="col-12">
        <custom-separator text="Resultados" />
      </div>
    </div>

    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />
    <section v-if="result" class="mt-4 mx-0">
      <div>
        <result-row
          v-for="(item, index) in result"
          :key="`${item.id}-${index}`"
          :item="item"
          :only-psc="onlyPsc"
          class="mb-4"
          :index="index"
          :active-index="activeIndex"
          :academicYear="filter.model.academicYear?.id"
          @saved="onSaveAmend()"
          @onSaveDiscussion="onSaveDiscussion()"
          @update-active-index="activeIndex = $event"
        />
      </div>
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </section>
  </div>
</template>

<script>
import mixAlert from '@/mixin/alert.mixin';
import storeMixin from '@/mixin/storeGenerator';

import ResultRow from './components/ResultRow';
import AcademicProgressCalendar from './components/AcademicProgressCalendar';
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';

import academicYearService from '@/services/academicyear';
import locationServices from '@/services/api/location.api';
import * as locationAlternativeApi from '@/views/pei/location-alternatives/_api';
import peiService from '@/services/pei/peiAcademicProgressCalendar.js';
import StatusLegend from './components/StatusLegend.vue';
import userRole from '@/utils/constants/userRoles';

export default {
  name: 'ProgressReportEducationalServices',
  mixins: [mixAlert, storeMixin],
  components: {
    FilterManager,
    ResultRow,
    AcademicProgressCalendar,
    PageHeader,
    Pagination,
    CustomSeparator,
    CustomResultNotFound,
    StatusLegend,
  },
  data: () => ({
    filter: {},
    page: {
      icon: 'fas fa-user-edit',
      title: 'Informe de Progreso para Servicios Educativos',
      routes: [
        'Inicio',
        'PEI',
        'Informe de Progreso para Servicios Educativos',
      ],
    },
    results: [],
    mounted: true,
    filter: {
      model: {
        academicYear: null,
        provider: null,
        status: null,
        week: null,
        sie: null,
        center: null,
        municipality: null,
        school: null,
        teacher: null,
        alternativeLocation: null,
        alternativeLocationCategory: null,
      },
      options: {
        academicYears: [],
        providers: [],
        statuses: [],
        weeks: [],
        centers: [],
        municipalities: [],
        schools: [],
        teachers: [],
        alternativeLocations: [],
        alternativeLocationCategories: [],
      },
    },
    result: [],
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 10,
    },
    isAcademicProgressCalendarVisible: false,
    activeIndex: null,
  }),
  computed: {
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filter.options.academicYears,
          value: this.filter.model.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          error: 'El año académico es requerido.',
          validations: 'required',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
          mapParentValue: this.filter.model.status == null,
        },
        {
          name: 'week',
          component: 'CustomDropDown',
          options: this.filter.options.weeks,
          value: this.filter.model.week,
          placeholder: 'Semana',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
          mapParentValue: this.filter.model.week == null,
          disabled: !this.filter.model.status,
          error: 'La semana es requerida.',
          validations: this.filter.model.status ? 'required' : '',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          value: this.filter.model.sie,
          placeholder: 'Escriba Nombre de Estudiante o SIE',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md-3',
          type: 'text',
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          options: this.filter.options.centers,
          value: this.filter.model.center,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.center == null,
          isAdvanced: true,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          options: this.filter.options.municipalities,
          value: this.filter.model.municipality,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.municipality == null,
          isAdvanced: true,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          options: this.filter.options.schools,
          value: this.filter.model.school,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.school == null,
          isAdvanced: true,
          error: 'Debe seleccionar la escuela.',
          validations: this.filterSchoolIsRequired ? 'required' : '',
        },
        {
          name: 'teacher',
          label: 'Maestro:',
          component: 'CustomDropDown',
          options: this.filter.options.teachers,
          value: this.filter.model.teacher,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.teacher == null,
          isAdvanced: true,
          disabled: this.filter.options.teachers.length == 1 && this.isTeacher,
        },
        {
          name: 'alternativeLocationCategory',
          label: 'Categoría Alternativa de Ubicación:',
          component: 'CustomDropDown',
          options: this.filter.options.alternativeLocationCategories,
          value: this.filter.model.alternativeLocationCategory,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.alternativeLocationCategory == null,
          isAdvanced: true,
        },
        {
          name: 'alternativeLocation',
          label: 'Alternativa de Ubicación:',
          component: 'CustomDropDown',
          options: this.filter.options.alternativeLocations,
          value: this.filter.model.alternativeLocation,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.alternativeLocation == null,
          isAdvanced: true,
        },
      ];
    },
    filterSchoolIsRequired() {
      return this.userRole === userRole.MaestroItinerante;
    },
    headerActionConfig() {
      return [
        {
          text: 'Calendario de Progreso Académico',
          icon: 'fas fa-calendar-alt',
          variant: 'success',
          visible: !this.isAcademicProgressCalendarVisible,
          click: () => this.showAcademicProgressCalendar(),
        },
        {
          text: 'Cerrar Calendario',
          icon: 'fas fa-times-circle',
          variant: 'outline-danger',
          visible: this.isAcademicProgressCalendarVisible,
          click: () => this.showAcademicProgressCalendar(false),
        },
      ];
    },
    isTeacher() {
      return this.userRole === userRole.maestro;
    },
    showNotResults() {
      return this.result.length == 0;
    },
    onlyPsc() {
      return this.$route.params.onlyPsc;
    },
    studentSieId() {
      return this.$route.params.studentSieId;
    },
  },
  async mounted() {
    await Promise.all([
      this.getAcademicYears(),
      this.getStatuses(),
      this.getWeeks(),
      this.getAlternativeLocationCategories(),
      this.getCenters(),
    ]);

    if (this.studentSieId) {
      this.filter.model.sie = this.studentSieId.toString();
    }
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const ROUTE_NAME_FROM = 'educational-services-program';

    next(async (vm) => {
      if (from.name == ROUTE_NAME_FROM) {
        vm.recoveryData();
        await vm.onPageChange(1, false);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
  methods: {
    async onPageChange(page, validate = true) {
      this.search(this.filter.model, page, validate);
      this.activeIndex = null;
    },
    async search(filters, page = 1, validate = true) {
      const isValid = validate
        ? await this.$refs.filter.$refs.formValidator.validate()
        : true;
      if (!isValid) return;

      try {
        const {
          academicYear,
          status,
          week,
          provider,
          sie,
          center,
          municipality,
          school,
          teacher,
          alternativeLocation,
          alternativeLocationCategory,
        } = filters;

        const mappedFilter = {
          academicYear: (academicYear || {}).id,
          status: (status || {}).id,
          week: (week || {}).id,
          provider: (provider || {}).id,
          centerId: (center || {}).id,
          municipalityId: (municipality || {}).id,
          StudentSieId: this.isASie(sie),
          firstName:
            isNaN(sie) && (typeof sie === 'string' || sie instanceof String)
              ? sie
              : null,
          schoolId: (school || {}).id,
          teacherId: (teacher || {}).id,
          alternativeLocationId: (alternativeLocation || {}).id,
          alternativeLocationCategoryId: (alternativeLocationCategory || {}).id,
          pageIndex: page,
          pageSize: 10,
          onlyPsc: this.onlyPsc,
        };

        const result = (
          await peiService.getStudentsByProgressAcademicYear(mappedFilter)
        ).data;

        this.result = result.data.map((x) => ({ ...x, isOpen: false }));
        this.pagination = {
          ...this.pagination,
          totalItemCount: result.totalItemCount,
          pageCount: result.pageCount,
          currentPage: result.currentPage,
          count: result.count,
        };
      } catch (error) {
        this.ShowToast(error.message, '', 'error');
      }
    },
    async validateMounted() {
      if (this.mounted) {
        this.mounted = false;
        if (!this.filterSchoolIsRequired)
          await this.searchHandler(this.filter.model);
      }
    },
    async searchHandler(filters) {
      await this.search(filters);
      this.activeIndex = null;
    },
    async getStatuses() {
      this.filter.options.statuses = [
        { id: 2, name: 'Pendiente' },
        { id: 3, name: 'Sometido' },
        { id: 4, name: 'Discutido' },
      ];
    },
    async getWeeks() {
      this.filter.options.weeks = [
        { id: 1, name: '10 semanas' },
        { id: 2, name: '20 semanas' },
        { id: 3, name: '30 semanas' },
        { id: 4, name: '40 semanas' },
        { id: 5, name: '50 Semanas (AEE)' },
      ];
    },
    async onAcademicYearChange(value) {
      this.filter.model.center = null;
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        centers: [],
        municipalities: [],
        schools: [],
        teachers: [],
      };

      if (!value) return;

      await this.getCenters();
    },
    async onStatusChange(value) {
      if (!value) {
        this.filter.model.week = null;
      }
    },
    async onCenterChange(value) {
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        municipalities: [],
        schools: [],
        teachers: [],
      };

      if (!value) return;

      await this.getMunicipalities();
    },
    async onMunicipalityChange(value) {
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        schools: [],
        teachers: [],
      };

      if (!value) return;

      await this.getSchools();
    },
    async onSchoolChange(value) {
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        teachers: [],
      };

      if (!value) return;

      await this.getTeachers();
    },
    async onAlternativeLocationCategoryChange(value) {
      this.filter.model.alternativeLocation = null;

      this.filter.options = {
        ...this.filter.options,
        alternativeLocations: [],
      };

      if (!value) return;

      await this.getAlternativeLocations();
    },
    async getAcademicYears() {
      const {
        data: academicYearsList,
      } = await academicYearService.getAcademicYearFromMin({
        minYearId: 27,
        yearType: 'CURRENT',
      });
      this.filter.options.academicYears = academicYearsList;
      this.filter.model.academicYear = this.currentAcademicYear();
    },
    async getCenters() {
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      locationServices
        .getCenters({ academicYearId: academicYearId })
        .then(({ data }) => {
          this.filter.options.centers = data;

          if (data.length == 1) {
            this.filter.model.center = data[0];
            this.getMunicipalities();
            return;
          }

          this.validateMounted();
        });
    },
    async getMunicipalities() {
      const centerId = (this.filter.model.center || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (centerId) {
        locationServices
          .getMunicipalities({ academicYearId, centerId })
          .then(({ data }) => {
            this.filter.options.municipalities = data;

            if (data.length == 1) {
              this.filter.model.municipality = data[0];
              this.getSchools();
              return;
            }

            this.validateMounted();
          });
      }
    },
    async getSchools() {
      const municipalityId = (this.filter.model.municipality || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (municipalityId) {
        locationServices
          .getSchools({ academicYearId, municipalityId })
          .then(({ data }) => {
            this.filter.options.schools = data;

            if (data.length == 1) {
              this.filter.model.school = data[0];
              this.getTeachers();
              return;
            }

            this.validateMounted();
          });
      }
    },
    async getTeachers() {
      const schoolId = (this.filter.model.school || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (schoolId) {
        locationAlternativeApi
          .getTeachersBySchool(academicYearId, schoolId)
          .then((data) => {
            this.filter.options.teachers = data;
            if (data.length == 1 && this.isTeacher) {
              this.filter.model.teacher = data[0];
            }

            this.validateMounted();
          });
      }
    },
    async getAlternativeLocationCategories() {
      const data = await locationAlternativeApi.getCategories();
      this.filter.options.alternativeLocationCategories = data;
    },
    async getAlternativeLocations() {
      const alternativeLocationCategoryId = (
        this.filter.model.alternativeLocationCategory || {}
      ).id;

      if (alternativeLocationCategoryId) {
        const data = await locationAlternativeApi.getNames({
          categoryId: alternativeLocationCategoryId,
        });
        this.filter.options.alternativeLocations = data;
      }
    },
    showAcademicProgressCalendar(show = true) {
      this.isAcademicProgressCalendarVisible = show;
    },
    async onSaveAmend() {
      await this.search(this.filter.model, this.pagination.currentPage, false);
    },
    isASie(sie) {
      return sie
        ? /^\s*[0-9]{8}\s*$/.test(sie)
          ? sie.replace(/\s+/g, '')
          : null
        : null;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .filter-manager_extended {
    border-radius: 0.25rem;
    @media only screen and (min-width: 750px) {
      .search-btn {
        &.col-lg-3 {
          flex: 0 0 10%;
          max-width: 10%;
          padding-left: 0;
        }
      }
    }
  }
}
</style>
